import type { CredentialFunnel } from "@/types";

/**
 * Attack-traffic totals for the Credential Health funnel.
 *
 * The funnel counts hostile sources only — addresses with no successful sign-in
 * in the page window — so a real user's typo or MFA fumble never lands here. What
 * the trusted sources contributed arrives separately (`excluded_trusted_attempts`,
 * `successful`) and is deliberately left out of these totals. This is the single
 * source of truth for the funnel's denominators so the bars and the page subtitle
 * can never drift.
 */
export interface AttackTotals {
  /** blocked + user_not_found + invalid_password + failed_second_factor. */
  readonly attackTotal: number;
  /** user_not_found + invalid_password + failed_second_factor — attempts that passed Shield. */
  readonly reachedCreds: number;
}

export function attackTotals(funnel: CredentialFunnel): AttackTotals {
  const reachedCreds =
    funnel.user_not_found + funnel.invalid_password + funnel.failed_second_factor;
  return {
    attackTotal: funnel.blocked + reachedCreds,
    reachedCreds,
  };
}

/** Shown by the funnel and its subtitle when there is no hostile traffic to break down. */
export function noAttackTrafficMessage(windowDays: number): string {
  return `No attack traffic from hostile sources in the last ${windowDays} days.`;
}
